module.exports = __webpack_public_path__ + "static/media/economics.94afda00.jpg";